import { render, staticRenderFns } from "./UserReport.vue?vue&type=template&id=e27d7cfa&scoped=true"
import script from "./UserReport.vue?vue&type=script&lang=js"
export * from "./UserReport.vue?vue&type=script&lang=js"
import style0 from "./UserReport.vue?vue&type=style&index=0&id=e27d7cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27d7cfa",
  null
  
)

export default component.exports